import {
  FormGridItem,
  type FormGridItemProps,
  TextField,
  type TextFieldProps,
  useFirstNameValidator,
} from '@ace-clublabs/shared-component-library';
import type React from 'react';
import { defaultInputProps, getRequiredFieldSx } from '../utils';

export interface FirstNameFieldProps {
  value?: string;
  onChange: (value: string) => void;
  required?: boolean;
  fieldProps?: Partial<TextFieldProps<'first-name'>>;
  validatorProps?: Parameters<typeof useFirstNameValidator>[0];
  gridItemProps?: Partial<FormGridItemProps>;
}

export const FirstNameField: React.FC<FirstNameFieldProps> = ({
  value,
  onChange,
  required = false,
  fieldProps,
  validatorProps,
  gridItemProps,
}) => {
  const label = 'First name';
  const validator = useFirstNameValidator({
    label,
    required,
    ...validatorProps,
  });

  return (
    <FormGridItem
      size={{ xs: 12, lg: 6 }}
      {...gridItemProps}
      sx={getRequiredFieldSx(required)}
    >
      <TextField
        for='first-name'
        label={label}
        {...defaultInputProps}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        validator={validator}
        data-testid='firstName'
        {...fieldProps}
      />
    </FormGridItem>
  );
};
